export default __webpack_public_path__ + "static/media/shoes-banner.aad8ef6c.jpg";